import {
  SELECT_FARM_FOR_DETAIL,

  GET_ACCOUNT_FARMS_REQUEST ,
  GET_ACCOUNT_FARMS_FAILURE,
  GET_ACCOUNT_FARMS_SUCCESS,

  FARM_POST_REQUEST,
  FARM_POST_SUCCESS,
  FARM_POST_FAILURE,

  FARM_PATCH_REQUEST,
  FARM_PATCH_SUCCESS,
  FARM_PATCH_FAILURE,

  DELETE_FARM_REQUEST,
  DELETE_FARM_SUCCESS,
  DELETE_FARM_FAILURE,
} from './farmActions';

const initialState = {
  pending: false,
  hasError: false,
  error: null,
  farmEntities: {},
  selectedFarmId: '',
};

const farmsReducer = (state = { ...initialState }, action) => {
  switch(action.type) {

    ////////////////////////
    // Get Handlers
    ////////////////////////
    case GET_ACCOUNT_FARMS_REQUEST: {
      return { ...state, pending: action.isFetching };
    }
    case GET_ACCOUNT_FARMS_SUCCESS: {
      const farmEntities = {};
      action.payload.forEach(entity => {
        farmEntities[entity.id] = entity;
      });
      return {
        ...state,
        pending: false,
        hasError: false,
        farmEntities
      };
    }
    case  GET_ACCOUNT_FARMS_FAILURE: {
      return {
        ...state,
        pending: false,
        hasError: true,
        error: action.error
      };
    }
    case SELECT_FARM_FOR_DETAIL: {
      return {
        ...state,
        selectedFarmId: action.farmId
      };
    }

    ////////////////////////
    // Create/Update Farm Handlers
    ////////////////////////
    case FARM_POST_REQUEST: {
      return { ...state, pending: action.isFetching };
    }
    case FARM_POST_SUCCESS: {
      const farmEntities = { ...state.farmEntities, [action.payload.id]: action.payload };
      return {
        ...state,
        pending: false,
        hasError: false,
        farmEntities
      }
    }
    case FARM_POST_FAILURE: {
      return {
        ...state,
        pending: false,
        hasError: true,
        error: action.error
      };
    }

    case FARM_PATCH_REQUEST: {
      return { ...state, pending: action.isFetching };
    }
    case FARM_PATCH_SUCCESS: {
      const farmEntities = { ...state.farmEntities, [action.payload.id]: action.payload };
      
      return {
        ...state,
        pending: false,
        hasError: false,
        farmEntities
      }
    }
    case FARM_PATCH_FAILURE: {
      return {
        ...state,
        pending: false,
        hasError: true,
        error: action.error
      };
    }

    ////////////////////////
    // Delete Handlers
    ////////////////////////
    case DELETE_FARM_REQUEST: {
      return { ...state, pending: action.isFetching };
    }
    case DELETE_FARM_SUCCESS: {
      const { farmId } = action;
      delete state.farmEntities[farmId];
      const newFarmEntities = Object.assign({}, state.farmEntities);
      return {
        ...state,
        pending: false,
        hasError: false,
        farmEntities: newFarmEntities
      }
    }

    case DELETE_FARM_FAILURE: {
      return {
        ...state,
        pending: false,
        hasError: true,
        error: action.error
      };
    }

    default: {
      return state;
    }
  }
}


export default farmsReducer;
